import Service from "./core/Service";

type LayoutState = {
  drawer: boolean;
  navbar: boolean;
};

class LayoutService extends Service<LayoutState> {
  protected state = {
    drawer: true,
    navbar: true  
  };

  get drawer() {
    return this.state.drawer;
  }

  set drawer(val: boolean) {
    this.setState({ drawer: val });
  }

  get navbar() {
    return this.state.drawer;
  }

  set navbar(val: boolean) {
    this.setState({ navbar: val });
  }
}

export const $layout = Service.singleton(LayoutService);
